import React from 'react'
import {
  $getSelection,
  $insertNodes,
  $isRangeSelection,
  COMMAND_PRIORITY_EDITOR,
  createCommand,
} from 'lexical'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import * as R from 'ramda'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'

import { $createTextVariableNode } from 'components/shared/FormFields/common/Editors/nodes/TextVariableNode/TextVariableNode'

import type { EditorVariable } from 'components/shared/FormFields/common/Editors/types'
import styles from './VariablesButtonSetPlugin.module.scss'

const INSERT_VARIABLE_COMMAND = createCommand<EditorVariable>()

export const VariablesButtonSetPlugin = ({
  variables,
}: {
  variables?: EditorVariable[]
}) => {
  const [editor] = useLexicalComposerContext()

  React.useEffect(() => {
    editor.registerCommand(
      INSERT_VARIABLE_COMMAND,
      ({ key, label }) => {
        const selection = $getSelection()

        if (!$isRangeSelection(selection)) return false

        const focusNode = selection.focus.getNode()

        if (focusNode !== null) {
          const node = $createTextVariableNode(key, label)

          $insertNodes([node])
          node.select()
        }

        return true
      },
      COMMAND_PRIORITY_EDITOR,
    )
  }, [editor])

  return (
    <Box align="center" className={styles.variables}>
      <p className={styles.text}>{t`Available variables:`}</p>
      <Box align="center">
        {R.map(
          ({ key, label }) => (
            <button
              className={styles.button}
              key={key}
              type="button"
              onClick={() =>
                editor.dispatchCommand(INSERT_VARIABLE_COMMAND, { key, label })
              }
            >
              {label}
            </button>
          ),
          variables,
        )}
      </Box>
    </Box>
  )
}
